module.exports = __webpack_public_path__ + "img/bike-woman.28996cc4.png";